export const Props = () => ({
  //--------------------------------------------------------------------------
  //                           Размер иконки со смайликом
  //--------------------------------------------------------------------------
  iconSize: {
    type: Number,
    required: false,
    default: 24,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});